import { DataRecord } from '../../../src_server/entity/dto/DataRecord';


import { FBRecordDTO } from '../../../src_server/entity/dto/FBRecordDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class PaymentTeacherService extends GeneratedBizBase{
  async getTeacherPaymentByUserID(firstDayOfMonth: string,building: string,target_date: string,user_id: string): Promise<Response<DataRecord>> {
    return super.restCall<Response<DataRecord>>('get', '/v1/PaymentTeacherService/getTeacherPaymentByUserID', arguments);
  }
  async getFBDataByMonth(firstDayOfMonth: string,building: string,selected: string,target_date: string): Promise<Response<FBRecordDTO>> {
    return super.restCall<Response<FBRecordDTO>>('get', '/v1/PaymentTeacherService/getFBDataByMonth', arguments);
  }
}
